import React, { FC } from "react";
import styled from "styled-components";
import { List } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../ducks";
import _ from "lodash";
import Card from "./card";
import { Enum_Location_Status } from "../../queries/auto-generated/schemas";
import { StyledList } from "../styled";
import Error from "../error";

const LocationList: FC = () => {
  const {
    data: { locations },
    error,
    loading,
  } = useSelector((state: RootState) => state.location);
  const visible = useSelector(
    (state: RootState) => state.ui.locationListVisible
  );

  return (
    <StyledList
      header={<h2>Pick a location</h2>}
      style={{ display: visible ? "" : "none" }}
      loading={loading && !error}
    >
      {!error ? (
        _.map(
          _.filter(
            locations,
            (location) => location.status === Enum_Location_Status.Active
          ),
          (location, index) => (
            <StyledListItem key={index}>
              <Card location={location} />
            </StyledListItem>
          )
        )
      ) : (
        <Error error={error} />
      )}
    </StyledList>
  );
};

const StyledListItem = styled(List.Item)`
  padding: 1em 1em 0;
  border-bottom: none !important;
  &:last-child {
    padding-bottom: 1em;
  }
`;

export default LocationList;
